import { render, staticRenderFns } from "./Opponents.vue?vue&type=template&id=9afbdc18&scoped=true"
import script from "./Opponents.vue?vue&type=script&lang=js"
export * from "./Opponents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afbdc18",
  null
  
)

export default component.exports